import { useMemo } from 'react';
import {
  CollectorScope,
  UserCollectorsQuery,
  useUserCollectorsQuery
} from 'graphql/types';

export const useUserCollectors = (
  scope: CollectorScope
): {
  data: UserCollectorsQuery | undefined;
  loading: boolean;
} => {
  const { loading, data } = useUserCollectorsQuery({
    variables: {
      input: { scope }
    }
  });

  return useMemo(
    () => ({
      loading,
      data
    }),
    [data, loading]
  );
};
